export { default } from './sandbox-outcome-footer';
